import { Clazz } from "../../types";
import ClazzService from "../../services/Clazz";

import useAuthorizedQuery from "../../common/hooks/useAuthorizedQuery";

import { makeQueryKey as makeFetchClazzQueryKey } from "./useFetchClazz";

export const makeQueryKey = (id?: Clazz["id"]) => [
  ...makeFetchClazzQueryKey(id),
  "syllabi",
];

function useListClazzSyllabi(id?: Clazz["id"]) {
  const key = makeQueryKey(id);

  return useAuthorizedQuery(
    key,
    () => {
      if (id) {
        return ClazzService.listClazzSyllabi(id);
      }

      throw new Error("clazz id is required");
    },
    { enabled: !!id }
  );
}

export default useListClazzSyllabi;
